interface GaugeBarProps {
  /** Anteil von 0 bis 100. Werte darueber werden gekappt. */
  percent: number;
  /** Der Wert, wie er dasteht. */
  display: string;
  label: string;
  /**
   * Was vorlesende Programme statt der Beschriftung hoeren.
   *
   * Gebraucht, wo die sichtbare Beschriftung erst durch ihre Umgebung
   * eindeutig wird -- die Bahn unter "Reaktionszeit" heisst dort schlicht
   * "Verbrauchte Frist", und erst der Satz daneben sagt, welche Frist
   * gemeint ist. Wer die Seite hoert, hat diese Umgebung nicht.
   */
  caption?: string;
  /**
   * Ab welchem Anteil gewarnt wird. Setzt einen Strich in die Bahn.
   *
   * Bei den Servicezusagen ist das der Wert aus ``warn_at_percent``: Der
   * Strich sagt, wo die Warnung kommt, und nicht erst die Farbe, wenn sie
   * schon da ist.
   */
  threshold?: number;
  tone?: 'neutral' | 'success' | 'warning' | 'danger';
}

/**
 * Eine einzelne Bahn mit Beschriftung -- fuer Anteile und Fristen.
 *
 * Sie steht ueberall dort, wo es genau eine Zahl gibt, die zwischen null und
 * hundert liegt: die Einhaltungsquote eines Kunden, die verbrauchte Frist
 * eines Tickets. Ein Ring waere fuer eine Zahl zu viel Flaeche, ein Balken in
 * einem Diagramm zu wenig Aufmerksamkeit.
 */
export function GaugeBar({
  percent,
  display,
  label,
  caption,
  threshold,
  tone = 'neutral',
}: GaugeBarProps) {
  const clamped = Math.min(100, Math.max(0, percent));

  return (
    <div className="chart-gauge">
      <div className="chart-gauge__head">
        <span className="chart-gauge__label">{label}</span>
        <strong className={`chart-gauge__value chart-gauge__value--${tone}`}>{display}</strong>
      </div>
      <div className="chart-gauge__track" role="img" aria-label={`${caption ?? label}: ${display}`}>
        <div
          className={`chart-gauge__fill chart-gauge__fill--${tone}`}
          style={{ width: `${String(clamped)}%` }}
        />
        {threshold !== undefined ? (
          <span
            className="chart-gauge__threshold"
            style={{ left: `${String(Math.min(100, Math.max(0, threshold)))}%` }}
            aria-hidden="true"
          />
        ) : null}
      </div>
    </div>
  );
}
